import React from "react";
import "./WhatWeBuild.scss";

const services = [
    {
        number: "01",
        icon: "</>",
        title: "Web Applications",
        description:
            "From customer-facing platforms to internal business tools, we build responsive web applications around your goals.",
        capabilities: ["Business platforms", "E-commerce", "Custom dashboards"],
    },
    {
        number: "02",
        icon: "▣",
        title: "Mobile Applications",
        description:
            "We create intuitive mobile experiences that connect your business with customers wherever they are.",
        capabilities: ["iOS & Android", "Cross-platform apps", "Connected services"],
    },
    {
        number: "03",
        icon: "▤",
        title: "Smart TV Applications",
        description:
            "We bring digital experiences to the big screen with applications designed for clear navigation and effortless interaction.",
        capabilities: ["Streaming experiences", "TV interfaces", "Remote navigation"],
    },
    {
        number: "04",
        icon: "⌁",
        title: "IoT Solutions",
        description:
            "We connect devices, software, and data to help businesses monitor operations and turn information into action.",
        capabilities: ["Device integration", "Live monitoring", "Automation"],
    },
];

const WhatWeBuild = () => {
    return (
        <section
            className="what-we-build"
            id="what-we-build"
            aria-labelledby="what-we-build-title"
        >
            <div className="what-we-build__inner">
                <div className="what-we-build__header">
                    <div>
                        <p className="what-we-build__eyebrow">Our Expertise</p>
                        <h2 id="what-we-build-title">
                            What We <span>Build.</span>
                        </h2>
                    </div>

                    <p className="what-we-build__intro">
                        Practical technology. Thoughtful design. We turn ideas into digital
                        products that help businesses connect, operate, and grow.
                    </p>
                </div>

                <ul className="what-we-build__grid">
                    {services.map((service) => (
                        <li className="what-we-build__card" key={service.number}>
                            <div className="what-we-build__card-top">
                <span className="what-we-build__icon" aria-hidden="true">
                  {service.icon}
                </span>

                                <span className="what-we-build__number" aria-hidden="true">
                  {service.number}
                </span>
                            </div>

                            <h3>{service.title}</h3>
                            <p className="what-we-build__description">
                                {service.description}
                            </p>

                            <ul className="what-we-build__capabilities">
                                {service.capabilities.map((capability) => (
                                    <li key={capability}>{capability}</li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>

                <div className="what-we-build__footer">
                    <p>Have an idea you want to bring to life?</p>
                    <a className="what-we-build__contact" href="/contact">
                        Let’s discuss your project
                        <span aria-hidden="true">↗</span>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default WhatWeBuild;